"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskInfo = void 0;
/**
* class to hold data about one task executed within the stop watch.
*/
class TaskInfo {
    constructor(taskName, timeMillis) {
        this._taskName = taskName;
        this._timeMillis = timeMillis;
    }
    get taskName() {
        return this._taskName;
    }
    get timeMills() {
        return this._timeMillis;
    }
    get percentage() {
        return this._percentage;
    }
    calculatePercentage(totalTimeMillis) {
        this._percentage = (this._timeMillis * 100 / totalTimeMillis).toFixed(2);
        return this._percentage;
    }
}
exports.TaskInfo = TaskInfo;
//# sourceMappingURL=taskinfo.js.map